import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from 'components/Button';
import TextField from 'components/form/TextInput';
import Dropzone from 'components/form/Dropzone';
import { uploadMedia } from 'services/media';
import { BUCKET_URL } from 'constants/index';
import { snack } from 'utils/toast';

const CardEditModal = ({ card, onCancel, onSave }) => {
  const [values, setValues] = React.useState({
    overlay_text: card.overlay_text,
    overlay_description: card.overlay_description,
    overlay_graphic_url: card.overlay_graphic_url,
  });
  const [image, setImage] = React.useState();

  const onRemove = () => {
    setImage(null);
    setValues({ ...values, overlay_graphic_url: null });
  };

  const handleSave = async () => {
    if (image && image.length) {
      try {
        const { location } = await uploadMedia(image[0]);
        const url = BUCKET_URL + location;
        return onSave({ ...values, overlay_graphic_url: url, hash: card.hash });
      } catch (e) {
        snack.error(e.message);
      }
    } else {
      return onSave({ ...values, hash: card.hash });
    }
  };

  const onTextChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography gutterBottom variant="h3">
          Edit Connect Card
        </Typography>
        <Typography color="text.secondary">
          Edit the fields to change your Card’s headline and description
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Typography paragraph fontWeight={500}>
              Edit cover
            </Typography>
            {!image && values.overlay_graphic_url ? (
              <Stack spacing={1} alignItems="center">
                <Paper variant="outlined">
                  <img
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxWidth: 200,
                      marginBottom: 8,
                    }}
                    src={card.overlay_graphic_url}
                  />
                </Paper>
                <Button
                  size="small"
                  color="secondary"
                  variant="outlined"
                  onClick={onRemove}
                >
                  Remove
                </Button>
              </Stack>
            ) : (
              <Dropzone onChange={setImage} />
            )}
          </Grid>
          <Grid item xs={12} md={7}>
            <TextField
              fullWidth
              label="Headline"
              name="overlay_text"
              value={values.overlay_text}
              onChange={onTextChange}
            />
            <TextField
              fullWidth
              label="Description"
              name="overlay_description"
              value={values.overlay_description}
              onChange={onTextChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="text">
          Cancel
        </Button>
        <Button onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CardEditModal;
